import React, { useState, useEffect } from "react";
import Axios from "axios";
import { Formik } from "formik";

import {
  CRUDLayout,
  Input,
  InputSearch,
  // ExportButton,
  CreateButton,
  ActionButton,
  DataStatus,
  UpdateButton,
  DeleteButton,
  Switch,
  Pagination,
  Select,
  Alert,
  Th,
  Td,
  Modal,
  ThFixed,
  TdFixed,
} from "components";
import { MappingCoaItemSumberDayaApi } from "api";
import { TableNumber } from "utilities";
import { ModalAction } from "./Comps";
import {
  formInitialValues,
  formSubmmitMapper,
  formValidationSchema,
} from "./Utils";

export const ListMappingCoaItemSumberDaya = ({ setNavbarTitle }) => {
  // Title
  const title = "MAPPING COA ITEM SUMBER DAYA";

  // STATE LOADING
  const [isLoading, setIsLoading] = useState(true);

  // STATE SEARCHING
  const [searchKey, setSearchKey] = useState("");

  // STATE DATA KELOMPOK
  const [data, setData] = useState([]);
  const [dropdownCoa, setDropdownCoa] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    page: "1",
    dataLength: "10",
    totalPage: "1",
    dataCount: "0",
  });

  const [modalConfig, setModalConfig] = useState({
    type: "add",
    show: false,
    data: {},
  });

  // KONFIGURASI ALERT
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
    show: false,
  });

  const [searchTime, setSearchTime] = useState(null);

  const mappingDropdownCoa = (data) =>
    data.map((val) => ({
      label: `${val.id} - ${val?.nama}`,
      value: val?.id ?? "",
    }));

  // FUNCTION GET DATA DARI SERVER
  const getData = () => {
    setIsLoading(true);

    Axios.all([
      MappingCoaItemSumberDayaApi.getPage({
        q: searchKey,
        page: paginationConfig.page,
        per_page: paginationConfig.dataLength,
      }),
      MappingCoaItemSumberDayaApi.dropdownCOA(),
    ])
      .then(
        Axios.spread((res, coa) => {
          setData(res?.data?.data?.data);
          setDropdownCoa(mappingDropdownCoa(coa?.data?.data));
          setPaginationConfig({
            ...paginationConfig,
            dataCount: res?.data?.data?.data_count,
            totalPage: res?.data?.data?.total_page,
          });
        })
      )
      .catch((err) => alert(err))
      .finally(() => {
        if (searchKey != "") {
          setAlertConfig({
            variant: "primary",
            text: `Hasil Pencarian : ${searchKey}`,
            show: true,
          });
        }
        setIsLoading(false);
      });
  };

  const onInputSearch = (text) => {
    const key = text.target.value;
    if (searchTime) clearTimeout(searchTime);
    setSearchTime(
      setTimeout(() => {
        setSearchKey(key);
        setAlertConfig({
          variant: "primary",
          text: `Hasil Pencarian : ${key}`,
          show: key === "" ? false : true,
        });
      }, 750)
    );
  };

  const formSubmitHandler = (value, { setSubmitting, resetForm }) => {
    setIsLoading(true);
    if (modalConfig.type === "edit") {
      MappingCoaItemSumberDayaApi.update(formSubmmitMapper(value))
        .then(() => {
          setAlertConfig({
            show: true,
            text: "Data berhasil diubah !!",
            variant: "primary",
          });
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            text: "Data gagal disimpan !!",
            variant: "danger",
          });
        })
        .finally(() => {
          resetForm({
            values: {
              namaItem: "",
              namaKategori: "",
              idItemSumberDaya: "",
              noCoa: "",
            },
          });
          setModalConfig({ data: {}, type: "add", show: false });
          setIsLoading(false);
          setSubmitting(false);
          getData();
        });
    }

    if (modalConfig.type === "add") {
      MappingCoaItemSumberDayaApi.create(formSubmmitMapper(value))
        .then(() => {
          setAlertConfig({
            show: true,
            text: "Data berhasil disimpan !!",
            variant: "primary",
          });
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            text: "Data gagal disimpan !!",
            variant: "danger",
          });
        })
        .finally(() => {
          resetForm({
            values: {
              namaItem: "",
              namaKategori: "",
              idItemSumberDaya: "",
              noCoa: "",
            },
          });
          setModalConfig({ data: {}, type: "add", show: false });
          setIsLoading(false);
          setSubmitting(false);
          getData();
        });
    }
  };

  // ON COMPONENT MOUNT
  useEffect(() => {
    setNavbarTitle(title); // SET JUDUL NAVBAR
    getData(); // GET DATA DARI SERVER

    return () => {
      setIsLoading(false);
    };
  }, [
    setNavbarTitle,
    paginationConfig?.page,
    paginationConfig?.dataLength,
    searchKey,
  ]);

  // TABLE COMPONENT
  const Table = () => {
    return (
      <>
        <CRUDLayout.Table>
          <thead>
            <tr className="text-center">
              <Th>No.</Th>
              <Th>Nama Item Sumber Daya</Th>
              <Th>Kategori Anggaran</Th>
              <Th>COA</Th>
              <ThFixed>Aksi</ThFixed>
            </tr>
          </thead>
          <tbody>
            {data.map((val, index) => {
              return (
                <tr key={val.id_kelompok_anggaran}>
                  <Td className="text-center" width="20px">
                    {TableNumber(
                      paginationConfig.page,
                      paginationConfig.dataLength,
                      index
                    )}
                  </Td>
                  <Td>{val.nama_item_sumber_daya ?? "-"}</Td>
                  <Td>{val.nama_kategori_anggaran ?? "-"}</Td>
                  <Td>{val.no_coa + " - " + val.nama_akun ?? "-"}</Td>
                  <TdFixed>
                    <div className="d-flex justify-content-center">
                      <UpdateButton
                        size="sm"
                        className="m-1"
                        onClick={() => {
                          setModalConfig({
                            show: true,
                            type: "edit",
                            data: val,
                          });
                        }}
                      />
                    </div>
                  </TdFixed>
                </tr>
              );
            })}
          </tbody>
        </CRUDLayout.Table>
        {data.length > 0 && (
          <Pagination
            dataLength={paginationConfig.dataLength}
            dataNumber={
              paginationConfig.page * paginationConfig.dataLength -
              paginationConfig.dataLength +
              1
            }
            dataPage={
              paginationConfig.dataCount < paginationConfig.dataLength
                ? paginationConfig.dataCount
                : paginationConfig.page * paginationConfig.dataLength
            }
            dataCount={paginationConfig.dataCount}
            currentPage={paginationConfig.page}
            totalPage={paginationConfig.totalPage}
            onPaginationChange={({ selected }) =>
              setPaginationConfig({
                ...paginationConfig,
                page: selected + 1,
              })
            }
            onDataLengthChange={(e) =>
              setPaginationConfig({
                ...paginationConfig,
                page: 1,
                dataLength: e.target.value,
              })
            }
          />
        )}
      </>
    );
  };

  return (
    <>
      <CRUDLayout>
        <CRUDLayout.Head>
          <CRUDLayout.HeadSearchSection>
            <div className="d-flex mb-3">
              <InputSearch
                onChange={(e) => {
                  onInputSearch(e);
                }}
              />
            </div>
          </CRUDLayout.HeadSearchSection>

          {/* Button Section */}
          <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
        </CRUDLayout.Head>

        {/* Alert */}
        <Alert
          show={alertConfig.show}
          showCloseButton={true}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() => setAlertConfig({ ...alertConfig, show: false })}
        />

        {isLoading ? (
          <DataStatus loading={isLoading} text="Memuat Data" />
        ) : !Array.isArray(data) ? (
          <DataStatus text="Tidak dapat memuat data" />
        ) : data.length > 0 ? (
          <>
            <b>List Data Item Sumber Daya</b>
            <Table />
          </>
        ) : (
          <DataStatus text="Tidak ada data" />
        )}

        <Formik
          enableReinitialize
          initialValues={formInitialValues(modalConfig?.data)}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {modalConfig?.show && (
            <ModalAction
              setModalConfig={setModalConfig}
              modalConfig={modalConfig}
              dropdown={dropdownCoa}
            />
          )}
        </Formik>
      </CRUDLayout>
    </>
  );
};
